import React from "react";
import "./download_app.scss";

const DownloadApp = () => {
  return (
    <div className="da-viewport-wrapper">
      <div className="da-main-container">
        <h1 className="da-hero-title">Download Zullu AI App</h1>

        <p className="da-hero-description">
          Start your generation anytime, anywhere with Zullu AI. Download the
          Zullu AI app on iOS or Android, and try all the best AI video and
          image models and tools on just your cell phone.
        </p>

        <div className="da-badge-group">
          <a
            href="https://apps.apple.com/in/app/zullu-ai/id6758661324"
            target="_blank"
            rel="noreferrer"
            className="da-store-anchor"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
              alt="Download on the App Store"
            />
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.zulluai"
            target="_blank"
            rel="noreferrer"
            className="da-store-anchor"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Get it on Google Play"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadApp;
